// frontend/src/services/bodegaService.js
import api from './api';

// Configurar URL base para Bodega
// Usa la misma lógica que api.js pero apunta a /api/bodega
const API_BASE_URL = process.env.REACT_APP_API_URL
  ? process.env.REACT_APP_API_URL.replace(/\/content\/?$/i, '/bodega')
  : 'http://localhost:8000/api/bodega';

const bodegaService = {
  // ============================================
  // BODEGAS
  // ============================================
  getBodegas: (params = {}) => {
    return api.get(`${API_BASE_URL}/bodegas/`, { params });
  },

  getBodega: (id) => {
    return api.get(`${API_BASE_URL}/bodegas/${id}/`);
  },

  createBodega: (data) => {
    return api.post(`${API_BASE_URL}/bodegas/`, data);
  },

  updateBodega: (id, data) => {
    return api.patch(`${API_BASE_URL}/bodegas/${id}/`, data);
  },

  deleteBodega: (id) => {
    return api.delete(`${API_BASE_URL}/bodegas/${id}/`);
  },

  // ============================================
  // CATEGORÍAS DE RECURSOS
  // ============================================
  getCategorias: (params = {}) => {
    return api.get(`${API_BASE_URL}/categorias/`, { params });
  },

  getCategoria: (id) => {
    return api.get(`${API_BASE_URL}/categorias/${id}/`);
  },

  createCategoria: (data) => {
    return api.post(`${API_BASE_URL}/categorias/`, data);
  },

  updateCategoria: (id, data) => {
    return api.patch(`${API_BASE_URL}/categorias/${id}/`, data);
  },

  deleteCategoria: (id) => {
    return api.delete(`${API_BASE_URL}/categorias/${id}/`);
  },

  // ============================================
  // RECURSOS DE BODEGA
  // ============================================
  getRecursos: (params = {}) => {
    return api.get(`${API_BASE_URL}/recursos/`, { params });
  },

  getRecurso: (id) => {
    return api.get(`${API_BASE_URL}/recursos/${id}/`);
  },

  createRecurso: (data) => {
    return api.post(`${API_BASE_URL}/recursos/`, data);
  },

  updateRecurso: (id, data) => {
    return api.patch(`${API_BASE_URL}/recursos/${id}/`, data);
  },

  deleteRecurso: (id) => {
    return api.delete(`${API_BASE_URL}/recursos/${id}/`);
  },

  // Custom action: Recursos con bajo stock
  getRecursosBajoStock: () => {
    return api.get(`${API_BASE_URL}/recursos/bajo_stock/`);
  },

  // ============================================
  // STOCKS
  // ============================================
  getStocks: (params = {}) => {
    return api.get(`${API_BASE_URL}/stocks/`, { params });
  },

  getStock: (id) => {
    return api.get(`${API_BASE_URL}/stocks/${id}/`);
  },

  // Custom action: Resumen por recurso
  getResumenPorRecurso: () => {
    return api.get(`${API_BASE_URL}/stocks/resumen_por_recurso/`);
  },

  // ============================================
  // MOVIMIENTOS DE INVENTARIO
  // ============================================
  getMovimientos: (params = {}) => {
    return api.get(`${API_BASE_URL}/movimientos/`, { params });
  },

  getMovimiento: (id) => {
    return api.get(`${API_BASE_URL}/movimientos/${id}/`);
  },

  createMovimiento: (data) => {
    return api.post(`${API_BASE_URL}/movimientos/`, data);
  },

  updateMovimiento: (id, data) => {
    return api.patch(`${API_BASE_URL}/movimientos/${id}/`, data);
  },

  deleteMovimiento: (id) => {
    return api.delete(`${API_BASE_URL}/movimientos/${id}/`);
  },

  // Custom action: Kardex
  getKardex: (params) => {
    return api.get(`${API_BASE_URL}/movimientos/kardex/`, { params });
  },

  // ============================================
  // SOLICITUDES DE BODEGA
  // ============================================
  getSolicitudesBodega: (params = {}) => {
    return api.get(`${API_BASE_URL}/solicitudes-bodega/`, { params });
  },

  getSolicitudBodega: (id) => {
    return api.get(`${API_BASE_URL}/solicitudes-bodega/${id}/`);
  },

  createSolicitudBodega: (data) => {
    return api.post(`${API_BASE_URL}/solicitudes-bodega/`, data);
  },

  aprobarSolicitudBodega: (id, data = {}) => {
    return api.post(`${API_BASE_URL}/solicitudes-bodega/${id}/aprobar/`, data);
  },

  rechazarSolicitudBodega: (id, data = {}) => {
    return api.post(`${API_BASE_URL}/solicitudes-bodega/${id}/rechazar/`, data);
  },

  // ============================================
  // SOLICITUDES DE RECURSO (COMPRA)
  // ============================================
  getSolicitudesRecurso: (params = {}) => {
    return api.get(`${API_BASE_URL}/solicitudes-recurso/`, { params });
  },

  getSolicitudRecurso: (id) => {
    return api.get(`${API_BASE_URL}/solicitudes-recurso/${id}/`);
  },

  createSolicitudRecurso: (data) => {
    return api.post(`${API_BASE_URL}/solicitudes-recurso/`, data);
  },

  aprobarSolicitudRecurso: (id, data = {}) => {
    return api.post(`${API_BASE_URL}/solicitudes-recurso/${id}/aprobar/`, data);
  },

  rechazarSolicitudRecurso: (id, data = {}) => {
    return api.post(`${API_BASE_URL}/solicitudes-recurso/${id}/rechazar/`, data);
  },

  // ============================================
  // GUIAS DE DESPACHO
  // ============================================
  getGuiasDespacho: (params = {}) => {
    return api.get(`${API_BASE_URL}/guias-despacho/`, { params });
  },

  getGuiaDespacho: (id) => {
    return api.get(`${API_BASE_URL}/guias-despacho/${id}/`);
  },

  createGuiaDespacho: (data) => {
    return api.post(`${API_BASE_URL}/guias-despacho/`, data);
  },

  updateGuiaDespacho: (id, data) => {
    return api.patch(`${API_BASE_URL}/guias-despacho/${id}/`, data);
  },

  deleteGuiaDespacho: (id) => {
    return api.delete(`${API_BASE_URL}/guias-despacho/${id}/`);
  },
};

export default bodegaService;
